var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGatsby(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.3134 0C22.6974 0 0.313354 22.384 0.313354 50C0.313354 77.616 22.6974 100 50.3134 100C77.9294 100 100.313 77.616 100.313 50C100.313 22.384 77.9294 0 50.3134 0ZM11.0574 50.52L49.7934 89.256C28.5214 88.98 11.3334 71.792 11.0574 50.52ZM59.1014 88.276L12.0374 41.212C16.0294 23.76 31.6494 10.736 50.3134 10.736C63.3574 10.736 74.9174 17.1 82.0574 26.892L76.6214 31.688C70.8294 23.384 61.2054 17.948 50.3134 17.948C36.4454 17.948 24.6334 26.756 20.1694 39.084L61.2294 80.14C71.2014 76.528 78.8694 68.112 81.4374 57.688H64.4213V50H89.5814C89.5773 68.664 76.5534 84.284 59.1014 88.276Z",
    fill: "#744C9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGatsby);
export default __webpack_public_path__ + "static/media/gatsby.fd01535e0b8bcea21e7dafa14e73e2a1.svg";
export { ForwardRef as ReactComponent };